import React from 'react';
export function PainSection() {
  return <section className="bg-navy py-6 sm:py-9" data-id="element-145" data-mp="1rs46ptzpuxd9">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-146" data-mp="38ygg4appgqne">
        <h2 className="text-[23px] leading-[1.05] text-white sm:text-[36px]" data-id="element-147" data-mp="38vu706n62332">
          Stop guessing what's causing{' '}
          <span className="text-diag" data-id="element-148" data-mp="2yzqymj1q187o">the engine problem</span>
        </h2>
        <div className="mt-2.5 h-1 w-14 bg-diag" aria-hidden="true" data-id="element-149" data-mp="2z1tu3iln7tjs" />
        <p className="mt-3 text-[14px] font-medium leading-snug text-steellight sm:text-[17px]" data-id="element-150" data-mp="2l7ki2vunoz7p">
          Engine cranks but won't start? Misfire, rough idle, hesitation or loss of
          power — but where is the actual fault? Fuel pressure, ignition, injectors,
          sensors, vacuum leaks, fuel trims... what should you test first? GASOLINE
          ENGINE DIAGNOSTIC PRO™ gives you an organized visual fault-finding system
          to help you understand symptoms, follow diagnostic paths and identify the
          cause more systematically.{' '}
          <strong className="font-bold text-white" data-id="element-151" data-mp="3rmr580mqut32">Diagnose. Test. Verify.</strong>
        </p>
      </div>
    </section>;
}